import { render, staticRenderFns } from "./Prestonb2s.vue?vue&type=template&id=862c6ffa&lang=pug&"
import script from "./Prestonb2s.vue?vue&type=script&lang=js&"
export * from "./Prestonb2s.vue?vue&type=script&lang=js&"
import style0 from "../assets/themes/prestonb2s/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports